var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrap" },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "period" } },
            [
              _c("el-date-picker", {
                attrs: {
                  placeholder: "Period",
                  clearable: "",
                  type: "daterange",
                  format: _vm.dateFormat,
                  "value-format": _vm.formDateFormat,
                },
                model: {
                  value: _vm.form.period,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "period", $$v)
                  },
                  expression: "form.period",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "period" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "350px" },
                  attrs: {
                    placeholder: "Representatives",
                    multiple: "",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.form.representative_ids,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "representative_ids", $$v)
                    },
                    expression: "form.representative_ids",
                  },
                },
                _vm._l(_vm.representativeOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  staticClass: "align-top",
                  attrs: { type: "primary" },
                  on: { click: _vm.build },
                },
                [_vm._v("Build")]
              ),
              _vm._v(" "),
              _vm._t("buttons"),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }